import {FC} from 'react';
import {useLocation} from 'react-router-dom';
import styled from 'styled-components';

import {useTheme} from '@shared/frontends/theme_context';

export const Footer: FC = () => {
  const location = useLocation();
  const {
    main: {accentColor, accentTextColor},
  } = useTheme();

  return (
    <Wrapper
      hidden={location.pathname === '/404'}
      $backgroundColor={accentColor}
      $color={accentTextColor}
    >
      <Container>{`Copyright © ${new Date().getFullYear()}`}</Container>
    </Wrapper>
  );
};
Footer.displayName = 'PageWrapper';

export const FOOTER_HEIGHT = 50;

const Wrapper = styled.footer<{$backgroundColor: string; $color: string}>`
  background-color: ${p => p.$backgroundColor};
  height: ${FOOTER_HEIGHT}px;
  color: ${p => p.$color};
  display: flex;
`;

const Container = styled.div`
  margin: auto;
`;
